const WifiDisconnected02Icon = /*#__PURE__*/ [
  ["path", { d: "M14.5002 15L9.50016 20M14.5002 20L9.50016 15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 13C14.7324 9 9.5 9 5.5 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8C8.31579 2.66669 15.6842 2.66668 22 7.99989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { WifiDisconnected02Icon as default };
//# sourceMappingURL=WifiDisconnected02Icon.js.map
